import React from 'react';
import './index.css';

export default function NotRolled() {
    return (
        <div className = 'NotRolled'>
           <div> W pokoju jeszcze nie losowano!</div>
            <div>(tylko osoba, która założyła pokój może kliknąć "Losuj"</div>
        </div>
    )
}